import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TDashboardApi } from './types';

export const dashboard: TDashboardApi = {
	getCacheRefresh: () =>
		http.get(endpoint.dashboard.CACHE_REFRESH).then((response) => response.data),
	getDashboardServices: () =>
		http.get(endpoint.dashboard.DASHBOARD_SERVICES).then((response) => response.data),
};
